import { Button, Card, Dialog, Inline, Stack, Text, vars } from '@etg/wings';
import { Illustration } from '@eti/components';
import { useDirection, useSiteContext, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { Tier } from '@eti/schema-types';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import EtgFaresCardContent from './EtgFaresCardContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cardStyles = css`
  border: solid ${vars.colors.divider} 1px;
`;
const equalButtonStyles = css`
  flex: 1;
`;
const texts = {
  closeButtonAriaLabelText: 'ScreenReader.Product.ETG.Fares.PersuasionModal.CloseButton.Text',
  persuasionModalTitleText: 'Product.ETG.Fares.PersuasionModal.Title.Text',
  persuasionModalDiscountZeroPercentageTitleText: 'Product.ETG.Fares.PersuasionModal.DiscountZeroPercentage.Title.Text',
  persuasionModalSubtitleText: 'Product.ETG.Fares.PersuasionModal.Subtitle.Text',
  persuasionModalDiscountZeroPercentageSubtitleText: 'Product.ETG.Fares.PersuasionModal.DiscountZeroPercentage.Subtitle.Text',
  skipButtonLabelText: 'Product.ETG.Fares.PersuasionModal.Skip.Button.Text',
  upgradeButtonLabelText: 'Product.ETG.Fares.PersuasionModal.Upgrade.Button.Text'
};
const EtgFaresPersuasionModal = ({
  bounds,
  dataTestId,
  hasDiscount,
  numberOfTravelersWithoutInfants,
  handleClosePersuasionModal,
  handleModalOptionSelect,
  handleSkipStep,
  isPersuasionModalOpen,
  sellableOptions
}) => {
  const {
    t
  } = useTranslation();
  const {
    isRTL
  } = useDirection();
  const {
    brand
  } = useSiteContext();
  const modalOption = sellableOptions.find(tier => tier.type === Tier.Premium);
  const {
    closeButtonAriaLabelText,
    persuasionModalDiscountZeroPercentageSubtitleText,
    persuasionModalDiscountZeroPercentageTitleText,
    persuasionModalSubtitleText,
    persuasionModalTitleText,
    skipButtonLabelText,
    upgradeButtonLabelText
  } = getTranslatedTexts(texts, t);
  if (!modalOption) {
    return null;
  }
  return /*#__PURE__*/_jsx(Dialog, {
    closeButtonAriaLabel: closeButtonAriaLabelText,
    "data-testid": dataTestId,
    id: "etg-fares-persuasion-modal",
    illustration: /*#__PURE__*/_jsx(Illustration, {
      "aria-hidden": "true",
      brand: brand.code,
      "data-testid": "etg-fares-persuasion-modal-illustration",
      height: 112,
      id: "etg-fares-persuasion-modal-illustration",
      mirrored: isRTL,
      width: 116
    }),
    isOpen: isPersuasionModalOpen,
    onDismiss: handleClosePersuasionModal,
    title: hasDiscount ? persuasionModalTitleText : persuasionModalDiscountZeroPercentageTitleText,
    children: /*#__PURE__*/_jsxs(Stack, {
      children: [/*#__PURE__*/_jsx(Text, {
        asHtml: true,
        children: hasDiscount ? persuasionModalSubtitleText : persuasionModalDiscountZeroPercentageSubtitleText
      }), /*#__PURE__*/_jsxs(Card, {
        className: cardStyles,
        children: [/*#__PURE__*/_jsx(Card.Section, {
          children: /*#__PURE__*/_jsx(Text, {
            variant: "18-emphasized",
            children: modalOption.title
          })
        }), /*#__PURE__*/_jsx(EtgFaresCardContent, {
          bounds: bounds,
          hasDiscount: hasDiscount,
          numberOfTravelersWithoutInfants: numberOfTravelersWithoutInfants,
          option: modalOption
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        align: "end",
        collapseBelow: "560px",
        spacing: 8,
        children: [/*#__PURE__*/_jsx(Button, {
          className: equalButtonStyles,
          onClick: handleSkipStep,
          children: skipButtonLabelText
        }), /*#__PURE__*/_jsx(Button, {
          className: equalButtonStyles,
          onClick: () => handleModalOptionSelect(modalOption),
          variant: "primary",
          children: upgradeButtonLabelText
        })]
      })]
    })
  });
};
export default EtgFaresPersuasionModal;
//# sourceMappingURL=EtgFaresPersuasionModal.js.map